<template>
    <svg :class="svgClass" aria-hidden="true" @click="svgClick">
        <use :xlink:href="iconName"></use>
    </svg>
</template>

<script>
    export default {
        name: 'svg-icon',
        props: {
            iconClass: {
                type: String,
                required: true
            },
            className: {
                type: String,
                default: ''
            },
            popupName: {
                type: String
            },
            isBack: true
        },
        computed: {
            svgClass() {
                if (this.className) {
                    return 'svg-icon ' + this.className
                } else {
                    return 'svg-icon'
                }
            },
            iconName() {
                return `#icon-${this.iconClass}`
            }
        },
        methods: {
            svgClick(e) {
                if (this.isBack) {
                    this.$router.back()
                }

                this.popupName && this.$parent.$parent.showPopup(this.popupName)
                
                // 通知给父组件
                this.$emit('svgClick', e)
            }
        },
    }
</script>

<style lang="sass" scoped>
@import '~styles/mixin.sass'
.svg-icon 
    width: px2rem(18)
    height: px2rem(17.5)
    vertical-align: -0.15em
    fill: currentColor // fill: inherit !important
    overflow: hidden
</style>


// WEBPACK FOOTER //
// src/components/SvgIcon/index.vue